import React from "react";
import "./Certificate.css";

import certificate1 from "../images/certicate.jpeg";
import certificate2 from "../images/certificate1.png";
import certificate3 from "../images/c1.jpeg";

const Certificate = () => {
  return (
    <section className="certificate-section">
      <div className="certificate-container">

        <div className="certificate-images">
          <img
            src={certificate3}
            alt="Certificate 1"
          />

          {/* <img
            src={certificate2}
            alt="Certificate 2"
          /> */}
        </div>
{/* 
        <div className="certificate-content">
          <h2>
            WE ARE <br />
            SEDEX CERTIFIED <br />
            ORGANIZATION
          </h2>

          <ul>
            <li>
              Also passed social compliance audits for many
              U.S. retailers, conducted by third parties
              including Intertek and Bureau Veritas
            </li>

            <li>
              Sedex Global member, and follow responsible
              and ethical business practices
            </li>

            <li>
              A C-TPAT Customs-Trade Partnership Against
              Terrorism supply chain security program led
              by U.S. Customs and Border Protection
            </li>
          </ul>
        </div> */}

      </div>
    </section>
  );
};

export default Certificate;